import { ServicePeriodCode } from "../graphql/schema";

export function findOfferByPeriod<T extends { period: { code: ServicePeriodCode } }>(
  periodCode?: ServicePeriodCode,
  offers?: T[],
) {
  return (offers ?? []).find((offer) => offer.period.code === periodCode);
}
